export default "__VITE_ASSET__$2eRv__X3S5V0lx7rBQ6KA__"